import { createAsyncThunk, AnyAction } from "@reduxjs/toolkit"
import { ThunkDispatch } from "redux-thunk"

import i18n from "config/i18n"
import { API } from "redux/api"
import { IssueValues } from "types"

export const createIssue = createAsyncThunk(
  "issue/create",
  async (values: IssueValues) => {
    const response = await API.post("/issues", { issue: values })
    return response.data
  },
)

export const makeIssue = (values: IssueValues) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise((resolve, reject) => {
      return dispatch(createIssue(values))
        .then(
          ({ payload }) => {
            const { error } = payload
            if (error) {
              reject(error)
            } else {
              resolve(i18n.t("notice.issue.create.success"))
            }
          },
          () => {
            reject(i18n.t("notice.issue.create.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}
